import _ from 'lodash'

import values from 'core/data-model/constants/values'
import { formatNumber } from 'core/service/lib/number-format'

const EXTRACT_PLAN_NAME = new RegExp('.*\\((.*)\\)')

function extractPlan(name) {
  const matched = EXTRACT_PLAN_NAME.exec(name)
  if (matched) return matched[1]
  return name
}

function selectedPlan({ riderInGroups, riderTarget, riderState }) {
  let selectedPlan = {}
  if (riderState.selectedPlan) {
    selectedPlan = _.cloneDeep(riderState.selectedPlan)
  } else {
    if (riderState.options?.length && riderState.options[0].values?.length === 1) {
      selectedPlan = riderState.options[0].values[0]
    }
  }

  selectedPlan.planCode = riderTarget.riderCode

  if (riderTarget.overrideFields?.showPlanAsSumAssured) {
    selectedPlan.plan = riderHandler.extractPlan(riderTarget.riderNameEN)
  }

  // if (!selectedPlan.sumAssured) {
  //   if (riderTarget.fixedSA === 'Y') {
  //     selectedPlan.sumAssured = riderTarget.minSA
  //   } else {
  //     selectedPlan.sumAssured = riderTarget.defaultSA
  //   }
  // }

  return selectedPlan
}

function selectedPlanWithNoPlan({ riderInGroups, riderTarget, riderState }) {
  return {
    planCode: '',
  }
}

function mapping_policy_empty(...args) {
  return {}
}

/**
 * createOptionWithAnyValueType
 * @param _riders {Record<string, any>[]}
 * @param _rider {Record<string, any>}
 */
function createOptionAnyValue(_riders, _rider) {
  return {
    package: false,
    options: [{ type: values.OPTION_ANY_VALUE, values: [] }],
  }
}

/**
 * createOptionWithAnyValueType
 * @param _riders {Record<string, any>[]}
 * @param _rider {Record<string, any>}
 */
function createOptionAnyValuePlanGroup(_riders, _rider) {
  return {
    package: false,
    options: [{ type: values.OPTION_ANY_VALUE_PLAN_GROUP, values: [] }],
  }
}

/**
 * createOptionAnyValueWithPackageRiders
 * @param riders {Record<string, any>[]}
 * @param _rider {Record<string, any>}
 */
function createOptionAnyValueWithPackageRiders(riders, _rider) {
  return {
    package: true,
    options: [{ type: values.OPTION_ANY_VALUE, values: [] }],
    packageRiders: riders.map((item) => item.riderCode),
  }
}

/**
 * createOptionValueFromListWithPackage
 * @param isPackage {boolean}
 */
function createOptionValueFromListWithPackage(isPackage) {
  /**
   * createOptionValueFromListWithPackage
   * @param riders {Record<string, any>[]}
   * @param _rider {Record<string, any>}
   */
  return (riders, _rider) => {
    return {
      package: isPackage,
      options: [
        {
          type: values.OPTION_VALUE_FROM_LIST,
          values: riders.map((item) => ({
            planCode: item.riderCode,
            text: formatNumber(item.minSA),
            value: item.minSA,
          })),
        },
      ],
      packageRiders: [],
    }
  }
}

/**
 * createOptionValueFromListForESCI
 * @param riders {Record<string, any>[]}
 * @param _rider {Record<string, any>}
 */
function createOptionValueFromListForESCI(riders, _rider) {
  return {
    package: true,
    options: [
      {
        type: values.OPTION_VALUE_FROM_LIST,
        values: riders
          .map((item) => ({
            planCode: item.riderCode,
            text: formatNumber(item.minSA),
            value: item.minSA,
            group: item.riderCode.endsWith('D')
              ? values.RIDER_OPTION_GROUP_DISCOUNT
              : values.RIDER_OPTION_GROUP_NO_DISCOUNT,
          }))
          .sort((a, b) => a.value - b.value),
      },
    ],
    packageRiders: [],
  }
}

/**
 * createOptionValueForMHP
 * @param riders {Record<string, any>[]}
 * @param rider {Record<string, any>}
 */
function createOptionValueForMHP(riders, rider) {
  const packageRiders = {}

  riders.forEach((item) => {
    const code_thailand = {}

    if (/MHP\d\S/.test(item.riderCode)) {
      // full_coverage
      code_thailand.full_coverage = item.riderCode
    }
    if (/MHPD\d\S/.test(item.riderCode)) {
      // deductible
      code_thailand.deductible = item.riderCode
    }
    if (/MHPC\d\S/.test(item.riderCode)) {
      // co_payment
      code_thailand.co_payment = item.riderCode
    }

    const plan = extractPlan(item.riderNameEN)

    if (packageRiders[plan]) {
      packageRiders[plan].codes.Thailand = {
        ...packageRiders[plan].codes.Thailand,
        ...code_thailand,
      }
    } else {
      packageRiders[plan] = {
        planCode: item.riderCode,
        plan: plan,
        defaultSumAssured: item.minSA,
        areasOfCover: ['Thailand'],
        codes: {
          Thailand: code_thailand,
        },
      }
    }
  })

  return {
    options: [
      {
        type: values.OPTION_VALUE_FROM_LIST,
        values: [
          {
            planCode: rider.riderCode,
            plan: extractPlan(rider.riderNameEN),
            areaOfCover: 'Thailand',
            planOptional: 'full_coverage',
          },
        ],
      },
    ],
    areasOfCover: {
      Worldwide: {
        text: 'ทั่วโลก',
        value: 'Worldwide',
      },
      Asia: {
        text: 'เอเชีย',
        value: 'Asia',
      },
      Thailand: {
        text: 'ประเทศไทย',
        value: 'Thailand',
      },
    },
    package: false,
    planOptionals: {
      full_coverage: {
        text: 'ไม่มีส่วนร่วมจ่าย Full Coverage',
        value: 'full_coverage',
      },
      deductible: {
        text: 'มีความรับผิดส่วนแรก Deductible',
        value: 'deductible',
      },
      co_payment: {
        text: 'มีค่าใช้จ่ายร่วม Copayment',
        value: 'co_payment',
      },
    },
    packageRiders: Object.values(packageRiders).sort((a, b) => b.defaultSumAssured - a.defaultSumAssured),
  }
}

/**
 * createOptionFixValueHideSumAssured
 * @param _riders {Record<string, any>[]}
 * @param _rider {Record<string, any>}
 */
function createOptionFixValueHideSumAssured(_riders, _rider) {
  return {
    package: false,
    options: [{ type: values.OPTION_FIXED_VALUE_HIDE_SUMASSURED, values: [] }],
  }
}

function createOptionFixValue(_riders, _rider) {
  return {
    package: false,
    options: [{ type: values.OPTION_FIXED_VALUE, values: [] }],
  }
}

function getRiderSelectedPlanCode(rider) {
  if (rider.selectedPlan?.fullPlanCode?.length) {
    return rider.selectedPlan.fullPlanCode
  }
  if (rider.selectedPlan?.planCode?.length) {
    return rider.selectedPlan.planCode
  }
  return rider.code
}

const normalizeRiderPlanCode = (planCode) => {
  switch (planCode) {
    case 'MCI1J':
    case 'MCI1S':
      return 'MCI1'
    case 'MCI2J':
    case 'MCI2S':
      return 'MCI2'
    default:
      return planCode
  }
}

export const riderHandler = {
  getRiderSelectedPlanCode,
  extractPlan,
  selectedPlan,
  AP: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  CIES: {
    createOption: createOptionAnyValuePlanGroup,
    mapping_policy: mapping_policy_empty,
  },
  CIUDR: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  CPR: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  DCI: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  ECARE: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  ESCI: {
    createOption: createOptionValueFromListForESCI,
    mapping_policy: mapping_policy_empty,
  },
  HBUDR: {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  HIC: {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  HSUDR: {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  MCI: {
    createOption: (riders, _rider) => {
      return {
        options: [
          {
            type: 'VALUE_FROM_LIST',
            package: false,
            values: riders.map((item) => ({
              planCode: normalizeRiderPlanCode(item.riderCode),
              fullPlanCode: item.riderCode,
              text: extractPlan(item.riderNameEN),
              value: item.minSA,
            })),
          },
        ],
        areasOfCover: {
          Thailand: {
            text: 'ประเทศไทย',
            value: 'Thailand',
          },
        },
      }
    },
    selectedPlan: ({ riderInGroups, riderTarget, riderState }) => {
      return riderState.options[0].values.find((item) => item.fullPlanCode === riderTarget.riderCode)
    },
    mapping_policy: mapping_policy_empty,
  },
  'MEA+': {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  MEB: {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  MEX: {
    createOption: createOptionValueFromListWithPackage(false),
    mapping_policy: mapping_policy_empty,
  },
  MHP: {
    createOption: createOptionValueForMHP,
    mapping_policy: mapping_policy_empty,
  },
  MRTAAP: {
    createOption: (riders, _rider) => ({
      package: false,
      options: [{ type: values.OPTION_FIXED_VALUE_HIDE_SUMASSURED, values: 50 }],
      optionsPlan: [
        {
          type: values.OPTION_VALUE_FROM_LIST,
          values: riders.map((item) => ({
            planCode: item.riderCode,
            text: item.riderCode,
            value: parseInt(item.riderCode.substring(1, 3)),
          })),
        },
      ],
    }),
  },
  PARIDER: {
    selectedPlan: ({ _riderInGroups, riderTarget, _riderState }) => {
      const riderPackage = riderTarget.overrideFields.options[0].values.find(
        (value) => value.planCode === riderTarget.riderCode
      )
      return {
        planCode: riderPackage.planCode,
        packageDetail: riderPackage.package,
      }
    },
    mapping_policy: mapping_policy_empty,
  },
  PBPDD: {
    createOption: createOptionFixValueHideSumAssured,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  PBPDDCI: {
    createOption: createOptionFixValueHideSumAssured,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  PBSDD: {
    createOption: createOptionFixValueHideSumAssured,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  PBSDDCI: {
    createOption: createOptionFixValueHideSumAssured,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  PLS: {
    createOption: createOptionAnyValueWithPackageRiders,
    mapping_policy: mapping_policy_empty,
  },
  TPDUDR: {
    createOption: createOptionAnyValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  WP: {
    createOption: createOptionFixValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  WPD: {
    createOption: createOptionFixValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  WPDD: {
    createOption: createOptionFixValue,
    selectedPlan: selectedPlanWithNoPlan,
    mapping_policy: mapping_policy_empty,
  },
  WPEIP85: {
    createOption: createOptionValueFromListWithPackage(true),
    mapping_policy: mapping_policy_empty,
  },
  WPTPD: {
    createOption: createOptionFixValueHideSumAssured,
    mapping_policy: mapping_policy_empty,
  },
  WPTPDCI: {
    createOption: createOptionFixValueHideSumAssured,
    mapping_policy: mapping_policy_empty,
  },
}
